export default [
  { name: 'Bocas del Toro', code: 'PA-1' },
  { name: 'Chiriquí', code: 'PA-4' },
  { name: 'Coclé', code: 'PA-2' },
  { name: 'Colón', code: 'PA-3' },
  { name: 'Darién', code: 'PA-5' },
  { name: 'Emberá', code: 'PA-EM' },
  { name: 'Herrera', code: 'PA-6' },
  { name: 'Kuna Yala', code: 'PA-KY' },
  { name: 'Los Santos', code: 'PA-7' },
  { name: 'Ngöbe-Buglé', code: 'PA-NB' },
  { name: 'Panamá', code: 'PA-8' },
  { name: 'Panamá Oeste', code: 'PA-10' },
  { name: 'Veraguas', code: 'PA-9' }
];
